window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};

(function ($) {
  REBASE.theme.locations = {
    // set a few constants for storage keys and data for use later
    SELECTED_LOCATION_STORAGE_KEY: "gliks_selected_location1",
    ALL_LOCATIONS_STORAGE_KEY: "gliks_all_locations",
    LOCATIONS_EXPIRATION_STORAGE_KEY: "gliks_all_locations_expiration",
    LOCATION_INTERACTION_STORAGE_KEY: "gliks_location_interaction",
    API_URL: "https://gliks.herokuapp.com/api",
    productStyleCodes: [],
    selectedVariantId: null,
    selectedLocation: null,
    inventory: [],
    cart: null,
    context: "",

    /**
     * Initializes our code
     * - this will bind all of our DOM events, as well as trigger anything that needs to happen immediately to setup
     * - we pass a `context` param to let us know where this is running ( `cart` || `product` || `checkout`)
     *
     * @param {string} context one of 'product', 'cart', or 'checkout' to determine which context we're running in
     */
    init: function (context, inital_style_codes) {
      this.context = context;
      
      if (this.context === "checkout") {
        if (inital_style_codes && inital_style_codes.length) {
          this.productStyleCodes = inital_style_codes.slice(0);
        }
      } else {
        // grab our cart data from the DOM
        this.cart = JSON.parse(document.getElementById("cart__json").innerHTML);

        // grab our product style code from the DOM
        this.getProductStyleCodes();
      }

      // get our stored location if we have it
      // this.selectedLocation = this.getSelectedLocation();

      // If we have a selected location stored, go ahead and display it, and fetch inventory
      // IMPORTANT: add to cart logic depends on inventory data existing, we should pretty much always 
      // have a selected location, one gets set by default when locations are fetched. When fetchLocations 
      // finishes fetchInventory will get called again by handleLocationChanged
      // if (this.selectedLocation && (context === "product" || context === "cart")) {
      //   this.displaySelectedLocation(this.selectedLocation);
      //   this.fetchInventory(this.selectedLocation.id, this.productStyleCodes);
      // }

      // check to see if we have stored/expired locations, if not fetch them
      // if (this.storedLocationsExpired()) {
      //   this.fetchLocations();
      // }

      // if (this.hasLocationInteraction()) {
      //   this.showLocationsUI();
      // }

              $(".product-action").removeClass("product-action--loading");

      // bind all of our event handlers for actions/triggers
      this.bindEvents();
    },

    bindEvents: function () {
      $(document).on(
        "change",
        '.location-selection:not(.location-selection--loading) .selection-form input[type="number"]',
        this.handleZipCodeSubmit.bind(this)
      );
      $(document).on(
        "click",
        ".selection-form button",
        this.handleZipCodeSubmit.bind(this)
      );
      $(document).on(
        "click",
        ".select-location",
        this.handleSelectLocation.bind(this)
      );
      $(document).on(
        "fetchingLocations",
        this.setFetchingLocationsUI.bind(this)
      );
      $(document).on("locationsFetched", this.setInitialLocation.bind(this));
      $(document).on("locationChanged", this.handleLocationChanged.bind(this));
      $(document).on(
        "fetchingInventory",
        this.setFetchingInventoryUI.bind(this)
      );
      $(document).on(
        "inventoryFetched",
        this.handleInventoryFetched.bind(this)
      );
      $(document).on(
        "change",
        'input[name="properties[_shipping]"]',
        this.handleChangeShippingType.bind(this)
      );
      $(document).on(
        "click",
        ".delivery-type-select",
        this.handleClickChangeType.bind(this)
      );
      $(document).on(
        "click",
        "#checkout-buttons #checkout",
        this.handleClickCheckout.bind(this)
      );
      $(document).on(
        "click",
        ".cart-modal__bg, cart-modal__close",
        this.closeCartModal.bind(this)
      );
      $(document).on(
        "click",
        ".current-location a",
        this.handleClickChangeLocation.bind(this)
      );
    },

    setInitialLocation: function (e, data) {
      var location = data.locations[0],
        selectedLocation = this.getSelectedLocation();

      this.setSelectedLocation(selectedLocation || location);
    },

    /**
     * Grab our selected location out of local storage
     */
    getSelectedLocation: function () {
      var location = null,
        locations = JSON.parse(
          localStorage.getItem(this.ALL_LOCATIONS_STORAGE_KEY)
        ),
        selectedLocationIsAvailable = false;

      if (!location || !locations) {
        return null;
      }

      locations.forEach(function (loc) {
        if (loc.id === location.id) {
          selectedLocationIsAvailable = true;
        }
      });

      return selectedLocationIsAvailable ? location : null;
    },

    /**
     * check if we have interacted with locations before
     *
     * @return {boolean}
     */
    hasLocationInteraction: function () {
      return localStorage.getItem(this.LOCATION_INTERACTION_STORAGE_KEY);
    },

    // Update our UI to show current store and remove default banner
    showLocationsUI: function () {
      $(".product-shipping-selection").addClass(
        "product-shipping-selection--store-visible"
      );
      $(".product-shipping-selection__default-banner").remove();
    },

    /**
     * Handle updating UI when search is happening
     */
    setFetchingLocationsUI: function () {
      $(".location-search-results").empty();
      $(".location-selection").addClass("location-selection--loading");
    },

    /**
     * Handle updating UI when inventory is being fetched
     */
    setFetchingInventoryUI: function () {
      $(".product-shipping-selection__item-inventory-banner").html(
        "Loading Availability..."
      );
    },

    // build HTML for none found list item
    buildNoneFound: function () {
      return '<li class="none-found">No Glik\'s locations found within 50 miles of this zipcode.</li>';
    },

    /**
     * Build HTML string for location result
     *
     * @param {object} location - the location result object
     * @return {string} the HTML string of a location result
     */
    buildSearchResult: function (location) {
      return (
        "<li><div><h5>" +
        location.info.name +
        "</h5><p>" +
        location.info.store_location_descriptor +
        '</p></div><button class="btn btn--small btn--alt select-location" data-location=\'' +
        JSON.stringify(location) +
        "'>Set store</button></li>"
      );
    },

    /**
     * Handle updating UI after search is completed
     *
     * @param {array} locations - sorted locations array
     */
    renderSortedLocations: function (locations) {
      $(".location-selection").removeClass("location-selection--loading");
      $(".location-search-results").empty();
      for (var i = 0; i < 5; i++) {
        if (locations[i]) {
          $(".location-search-results").append(
            this.buildSearchResult(locations[i])
          );
        }
      }
    },

    /**
     * Handle updating UI with selected location
     */
    displaySelectedLocation: function (location) {
      $(".current-location").html(
        "<div><h5>" +
          location.info.name +
          "</h5><p>" +
          location.info.store_location_descriptor +
          '</p></div><a href="javascript:void(0)" class="btn btn--alt btn--small">Change</a>'
      );
    },

    /**
     * Given a zip code, this sorts our locations by distance from that zip code
     *
     * @param {string} zipcode - zipcode of selected location to measure distance from
     * @return {array} - our list of all locations, sorted by distance from given zipcode
     */
    sortLocationsByDistance: async function (zipcode) {
      var locations = JSON.parse(
          localStorage.getItem(this.ALL_LOCATIONS_STORAGE_KEY)
        ),
        coords = await this.getCoordsFromZipcode(zipcode);

      locations = locations.sort(
        function (a, b) {
          var distance_a = this.calculateDistance(coords, {
            lat: a.latitude,
            lng: a.longitude,
          });
          var distance_b = this.calculateDistance(coords, {
            lat: b.latitude,
            lng: b.longitude,
          });
          return distance_a - distance_b;
        }.bind(this)
      );

      return locations;
    },

    /**
     * Fetches all locations from the API
     *
     * @return {array} array of locations, or empty array if none
     */
    fetchLocations: async function () {
      var url = this.API_URL + "/locations.json",
        locations = [],
        date = new Date();

      $(document).trigger("fetchingLocations");
      var response = await await fetch(url)
        .then(function (res) {
          return res.json();
        })
        .catch(function (err) {
          console.log(err);
        });

      locations = response.locations;
      localStorage.setItem(
        this.ALL_LOCATIONS_STORAGE_KEY,
        JSON.stringify(locations)
      );
      localStorage.setItem(
        this.LOCATIONS_EXPIRATION_STORAGE_KEY,
        date.getTime() + 15 * 60000
      ); // sets an expiration date 15 minutes into future

      $(document).trigger("locationsFetched", { locations: locations });
      return locations;
    },

    /**
     * Get inventory data from our API, trigger events, and store data
     *
     * @param {integer} storeId - the id of the location to search
     * @param {array} style_codes - array of product style codes to check for
     * @return {object} the inventory response data
     */
    fetchInventory: async function (storeId, style_codes) {
      var url = this.API_URL + "/inventory.json",
        postData = JSON.stringify({
          store: storeId,
          style_code: style_codes,
        });

      $(document).trigger("fetchingInventory");
      var response = await await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: postData,
      })
        .then(function (res) {
          return res.json();
        })
        .catch(function (err) {
          console.log(err);
        });

      this.inventory = response.products;
      $(document).trigger("inventoryFetched", { inventory: response });
      return response;
    },

    /**
     * check if all items in a cart are in stock
     *
     * @param {array} skus - array of strings in format: 'product_style_code:variant_sku:qty', used to match against inventory response
     * @param {string} type - one of 'pickup' or 'shipped'
     * @return {boolean} - true if all items are in stock, false if any item is out of stock
     */
    allItemsInStock: function (skus, type) {
      var inventory_key =
          type === "pickup"
            ? "inventory_quantity"
            : "shopify_inventory_quantity", // which key should we look to for inventory, app or shopify
        inStock = true; // inStock by default

      skus.forEach(
        function (sku) {
          var split_sku = sku.split(":");
          if (
            !this.isItemInStock.apply(this, [split_sku[0], split_sku[1], inventory_key, split_sku[2]]).inStock
          ) {
            inStock = false;
          }
        }.bind(this)
      );

      return inStock;
    },

    /**
     * Check if a single item is in stock
     *
     * @param {array} prod_style_code - the product style code to check inventory for
     * @param {array} sku - the variant sku to check inventory for
     * @param {string} key - one of 'inventory_quantity' or 'shopify_inventory_quantity', the key to check inventory on
     * @param {integer} qty - qty of item in cart
     * @return {boolean} - true if item is stock, false otherwise
     */
    isItemInStock: function (prod_style_code, sku, key, qty) {
      var inStock = true,
        available = true;

      var prod = this.inventory.filter(function (prod) {
        return prod.style_code == prod_style_code;
      })[0];

      var variant = prod.variants.filter(function (prod_variant) {
        return prod_variant.in_house_upc.toString() === sku.toString();
      })[0];

      if (variant[key] === 0) {
        available = false;
      }

      if (variant[key] < qty) {
        inStock = false;
      }

      return {
        available: available,
        inStock: inStock,
      };
    },

    /**
     * Store a selected location in LocalStorage, and update the UI
     *
     * @param {object} location - our location to store
     */
    setSelectedLocation: function (location) {
      localStorage.setItem(
        this.SELECTED_LOCATION_STORAGE_KEY,
        JSON.stringify(location)
      );
      this.displaySelectedLocation(location);
      $(".location-search-results").empty();
      $(document).trigger("locationChanged", { location: location });
    },

    /**
     * Update Cart UI after inventory is fetched
     * - will toggle out-of-stock message
     */
    setCartInventoryUI: function () {
      var type = $(".delivery-switch--selected").data("type");
      key =
        type === "pickup" ? "inventory_quantity" : "shopify_inventory_quantity";

      $(".cart-row").each(
        function (i, el) {
          var data = $(el).data();
          var inventoryData = this.isItemInStock(
            data.prodStyleCode,
            data.variantSku,
            key,
            data.qty
          );

          if (!inventoryData.available) {
            $(el)
              .find(".inventory-notice")
              .removeClass("inventory-notice--visible");
            $(el).find(".sold-out-notice").addClass("sold-out-notice--visible");
            $("#checkout").data("block", true);
            $("#checkout").data(
              "modal-message",
              "Some items in your cart are no longer in stock for your selected delivery method."
            );
          } else if (!inventoryData.inStock) {
            $(el)
              .find(".sold-out-notice")
              .removeClass("sold-out-notice--visible");
            $(el)
              .find(".inventory-notice")
              .addClass("inventory-notice--visible");
            $("#checkout").data("block", true);
            $("#checkout").data(
              "modal-message",
              "Some items/quantities in your cart are no longer in stock for your selected delivery method."
            );
          }

          if (inventoryData.available && inventoryData.inStock) {
            $(el)
              .find(".inventory-notice")
              .removeClass("inventory-notice--visible");
            $(el)
              .find(".sold-out-notice")
              .removeClass("sold-out-notice--visible");
            $("#checkout").data("block", false);
          }

          // if ( inventoryData ) {
          //   $(el).find('.sold-out-notice').removeClass('sold-out-notice--visible');
          //   $('#checkout').data('block', false);
          // } else {
          //   $(el).find('.sold-out-notice').addClass('sold-out-notice--visible');
          //   $('#checkout').data('block', true);
          //   $('#checkout').data('modal-message', 'Some items in your cart are no longer in stock for your selected delivery method.')
          // }
        }.bind(this)
      );
    },

    /**
     * Handle updating UI after location is selected
     *
     * @param {string} e - jquery Event
     */
    handleSelectLocation: function (e) {
      e.preventDefault();
      var locationData = $(e.target).data("location");
      this.setSelectedLocation(locationData);
      $(".selection-form").removeClass("selection-form--visible");
      $(".current-location a").show();
    },

    /**
     * Handles event when submitting a zip code
     *
     * @param {string} e - jquery Event object
     */
    handleZipCodeSubmit: async function (e) {
      var val = $('.selection-form input[type="number"]').val();

      e.preventDefault();

      if (val.length === 5) {
        e.preventDefault();
        this.renderSortedLocations(await this.sortLocationsByDistance(val));
      } else {
        $(".location-search-results").html(this.buildNoneFound());
      }

      // remove our locations cache key to bust that cache and force new locations fetch next page load
      localStorage.removeItem(this.LOCATIONS_EXPIRATION_STORAGE_KEY);
    },

    /**
     * Handles event for when a new location is selected
     *
     * @param {object} e - jquery event
     * @param {string} data - additional location data passed through jquery event
     */
    handleLocationChanged: function (e, data) {
      if (data.location && data.location.id) {
        this.fetchInventory(data.location.id, this.productStyleCodes);
      }
    },

    /**
     * Handles actions taken after inventory fetched
     */
    handleInventoryFetched: function () {
      if (this.context === "product") {
        var inventoryVariant = this.getSelectedVariantInventory();
        if (inventoryVariant) {
          this.handleUpdateInventoryUI(inventoryVariant);
        }

        $(".product-action").removeClass("product-action--loading");
      }

      if (this.context === "cart") {
        this.setCartInventoryUI();
      }
    },

    /**
     * Update our UI based on a provided variants inventory

     * @param {object} inventoryVariant item from our inventory data for selected variant
     */
    handleUpdateInventoryUI: function (inventoryVariant) {
      var banner = $(".product-shipping-selection__item-inventory-banner"),
        qty = inventoryVariant.inventory_quantity;

      banner.html(qty + " available at this store.");
      banner.toggleClass(
        "product-shipping-selection__item-inventory-banner--sold-out",
        qty <= 0
      );
    },

    handleChangeShippingType: function () {
      $(document).trigger("locationInventoryUpdated");
      this.setLocationInteraction();
    },

    /**
     * Handle when a user selects to change all cart item shipping types
     *
     * @param {object} e - jQuery event object
     */
    handleClickChangeType: function (e) {
      e.preventDefault();
      var type = $(e.currentTarget).data("type");

      this.cart.items.forEach(function (item, index) {
        CartJS.updateItem(index + 1, item.quantity, { _shipping: type });
      });
    },

    /**
     * Handle possibly blocking and showing a message if checkout disabled
     *
     * @param {object} e - jQuery event object
     */
    handleClickCheckout: function (e) {
      var el = $(e.currentTarget);
      if (el.data("block")) {
        e.preventDefault();
        this.openCartModal(el.data("modal-message"));
      }
    },

    handleClickChangeLocation: function () {
      $(".selection-form").addClass("selection-form--visible");
      $(".current-location a").hide();
    },

    disableQuickPickup: function () {
      $(".product-shipping-selection__item-inventory-banner").html(
        "Item not available for Quick Pickup"
      );
      $(".product-shipping-selection__item--pickup").addClass(
        "product-shipping-selection__item--disabled"
      );
    },

    /**
     * Handle possibly blocking and showing a message if checkout disabled
     *
     * @param {string} message - The message you'd like to display inside the modal
     */
    openCartModal: function (message) {
      $("body").addClass("cart-modal-open");
      $(".cart-modal__content").text(message);
    },

    closeCartModal: function () {
      $("body").removeClass("cart-modal-open");
    },

    /**
     * Uses Google API to geolocate a provided zip code
     *
     * @param {string} zipcode - the zip code to geolocate
     * @return {object} a location coordinates object containing `lat` and `lng`
     */
    getCoordsFromZipcode: async function (zipcode) {
      var url =
          "https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:" +
          zipcode +
          "&key=AIzaSyCKuJtGY7yPo3-UXC-bgKeQD0QYmotBiQU",
        coords = null;

      var response = await await fetch(url)
        .then(function (res) {
          return res.json();
        })
        .catch(function (err) {
          console.log(err);
        });

      if (response.status === "OK" && response.results.length) {
        coords = response.results[0].geometry.location;
      }

      return coords;
    },

    /**
     * Filters our product variants array to return only the selected variant data

     * @return {object} the data object for our selected variant
     */
    getSelectedVariantData: function () {
      if (this.context == "product") {
        return REBASE.theme.productVariants.filter(
          function (v) {
            return v.id === parseInt(this.selectedVariantId);
          }.bind(this)
        )[0];
      }
    },

    /**
     * Returns the selected variant inventory from our fetched inventory data

     * @return {object} the inventory data for our selected variant
     */
    getSelectedVariantInventory: function () {
      var selectedVariant = this.getSelectedVariantData(),
        inventory = null;

      if (!this.inventory || !this.inventory.length) {
        return null;
      }

      try {
        // use selectedVariant data to pick out our inventory object
        inventory = this.inventory[0].variants.filter(function (v) {
          return v.in_house_upc === selectedVariant.sku;
        })[0];
      } catch (e) {
        console.warn(
          "No Product found for inventory, falling back to using Shopify inventory"
        );
      }

      if (inventory === null) {
        this.disableQuickPickup();
        return null;
      } else {
        return inventory;
      }
    },

    getProductStyleCodes: function () {
      $(".prod-style-code").each(
        function (i, el) {
          this.productStyleCodes.push($(el).text());
        }.bind(this)
      );
    },

    /**
     * Given two sets of coordinates, returns distance in miles between the two
     *
     * @param {object} coords1 - first set of lat/lng {lat:'', lng: ''}
     * @param {object} coords2 - second set of lat/lng {lat:'', lng: ''}
     * @return {number} distance in miles between the two coords
     */
    calculateDistance: function (coords1, coords2) {
      if (coords1.lat == coords2.lat && coords1.lng == coords2.lng) {
        return 0;
      } else {
        var radlat1 = (Math.PI * coords1.lat) / 180;
        var radlat2 = (Math.PI * coords2.lat) / 180;
        var theta = coords1.lng - coords2.lng;
        var radtheta = (Math.PI * theta) / 180;
        var dist =
          Math.sin(radlat1) * Math.sin(radlat2) +
          Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = (dist * 180) / Math.PI;
        dist = dist * 60 * 1.1515;
        return dist;
      }
    },

    setLocationInteraction: function () {
      localStorage.setItem(this.LOCATION_INTERACTION_STORAGE_KEY, true);
      this.showLocationsUI();
    },

    /**
     * Checks for existence of localStorage expiration item and sees if it is expired
     * @return {boolean} true if expired or non-existent
     */
    storedLocationsExpired: function () {
      var expiration = localStorage.getItem(
        this.LOCATIONS_EXPIRATION_STORAGE_KEY
      );
      if (expiration) {
        return Date.now() > new Date(parseInt(expiration));
      } else {
        return true;
      }
    },
  };
})(jQuery);
